import { uncapitalize } from '@attain-apps/string-utils'

import * as core from '../../../../../../core'
import * as common from '../../../../../common'

import * as idcFunctionType from './idc-function-type'

// NOTE: everything below is designed to simulate a normal folder/module
// structure for exporting resources from separate files. This just simply
// generates those resources based on the known enum entries

const enumId = core.dms.models.Enum.Id.from({
  partialId: idcFunctionType.RESOURCE.payload.partialId,
})

const enumEntryResourceNameLookup = {} as Record<common.FaFunction.Type, string>
for (const enumEntryName in common.FaFunction.Type) {
  const potentialEnum =
    common.FaFunction.Type[enumEntryName as keyof typeof common.FaFunction.Type]
  if (common.FaFunction.Type.isType(potentialEnum)) {
    enumEntryResourceNameLookup[potentialEnum] = uncapitalize(enumEntryName)
  }
}

export const entries = common.FaFunction.Type.ALL.reduce(
  (prev, _idcFunctionType) =>
    Object.assign(prev, {
      [enumEntryResourceNameLookup[_idcFunctionType]]: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        RESOURCE: {
          payload: {
            ...common.FaFunction.Type.getEntry(_idcFunctionType),
            enumId,
          },
          type: core.quiver.Resource.Type.DmsEnumEntry,
        } as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>,
      },
    }),
  {} as {
    [K in keyof typeof common.FaFunction.Type as (typeof common.FaFunction.Type)[K] extends common.FaFunction.Type
      ? Uncapitalize<K>
      : never]: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      RESOURCE: core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
    }
  },
)
